import type { SVGAttributes } from 'react';

export function DonationsIcon(props: SVGAttributes<SVGSVGElement>) {
	return (
		<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
			<path
				opacity="0.4"
				d="M24.6666 16.8665V21.7999C24.6666 25.9599 20.7866 29.3332 15.9999 29.3332C11.2133 29.3332 7.33325 25.9599 7.33325 21.7999V16.8665C7.33325 21.0265 11.2133 23.9999 15.9999 23.9999C20.7866 23.9999 24.6666 21.0265 24.6666 16.8665Z"
				stroke="currentColor"
				strokeWidth="2"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M24.6666 10.2C24.6666 11.4133 24.3332 12.5333 23.7466 13.4933C22.3199 15.84 19.3866 17.3333 15.9999 17.3333C12.6133 17.3333 9.67992 15.84 8.25326 13.4933C7.66659 12.5333 7.33325 11.4133 7.33325 10.2C7.33325 8.11999 8.30658 6.23999 9.86658 4.87999C11.4399 3.50666 13.5999 2.66666 15.9999 2.66666C18.3999 2.66666 20.5599 3.50666 22.1333 4.86666C23.6933 6.23999 24.6666 8.11999 24.6666 10.2Z"
				stroke="currentColor"
				strokeWidth="2"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M24.6666 10.2V16.8667C24.6666 21.0267 20.7866 24 15.9999 24C11.2133 24 7.33325 21.0267 7.33325 16.8667V10.2C7.33325 6.03999 11.2133 2.66666 15.9999 2.66666C18.3999 2.66666 20.5599 3.50666 22.1333 4.86666C23.6933 6.23999 24.6666 8.11999 24.6666 10.2Z"
				stroke="currentColor"
				strokeWidth="2"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	);
}
